import { Table } from "antd"
import { Skeleton } from ".."

const DataTableSkeleton = ({ rowCount = 10, columns = [], skeletonType = "small" }) => {
  const baseCols = columns?.length ? columns : [...Array(3)].map((_, i) => ({ title: "", dataIndex: `sk-${i}` }))

  const defaultSkeleton = () => (
    <Skeleton active size="small" style={{ width: "100%", height: skeletonType === "large" ? 24 : 20, marginBottom: skeletonType === "large" ? 12 : 0 }} />
  )

  const actionSkeleton = () => (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, width: "100%", paddingRight: 8 }}>
      {[...Array(3)].map((_, i) => (
        <Skeleton key={i} type="button" active size="small" shape="circle" style={{ width: 32, height: 32 }} />
      ))}
    </div>
  )

  const renderColumns = () =>
    baseCols?.map(col => {
      const isActions = ["actions", "action"].includes(col?.dataIndex ?? "")
      const isFavorite = col?.dataIndex === "favorite"
      return {
        ...col,
        title: isFavorite ? "" : isActions ? (
          <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", paddingRight: 8 }}>
            <Skeleton active size="small" style={{ width: 96, height: 16, borderRadius: 6 }} />
          </div>
        ) : (
          <Skeleton active size="small" style={{ width: 60, height: 16 }} />
        ),
        render: () => (isFavorite ? null : isActions ? actionSkeleton() : defaultSkeleton()),
      }
    })

  return <Table dataSource={[...Array(rowCount)].map((_, i) => ({ key: `skeleton-${i}` }))} columns={renderColumns()} pagination={false} loading={false} />
}

export default DataTableSkeleton
